import React, {useContext, useEffect, useRef, useState} from 'react';
import MessageBroker from 'deprecated-shared-ui/components/message-broker';
import Messages from '@core/scripts/components/messages.js';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import FilterGroupContent from './FilterGroupContent.jsx';
import {Accordion} from '@bonprix/design-system';
import Ordering from '../header/Ordering.jsx';
import {Constants} from '../view-constants.js';
import {sendViewedFiltersEvent} from '@shopping-funnel/scripts/helper/algolia-tracking';
import {getAlgoliaFilterStringsFromFilterOptions} from '@shopping-funnel/scripts/helper/algolia-filter-context.ts';

function FilterAccordion({filterGroups, ordering, filterOptionChange, orderingChange, classes}) {
    const {texts} = useContext(articleOverviewStaticContext);

    const [isMounted, setIsMounted] = useState(false);
    const [selectedOrderingName, setSelectedOrderingName] = useState(ordering.find((option) => option.selected).name);
    const activeIdentifiers = useRef([]);
    const viewedFilterGroups = useRef(new Set());

    useEffect(() => {
        setTimeout(() => {
            setIsMounted(true);
        }, 0);
        MessageBroker.publish(Messages.DOM.CHANGED);
    }, []);

    const handleOrderingChange = (value, landmark, name) => {
        setSelectedOrderingName(name);
        orderingChange(value, landmark);
    };

    return (
        <div className={`filter__groups-accordion ${classes}`} jsh-accordion-wrapper="">
            <Accordion>
                {ordering && renderOrdering()}
                {filterGroups.map((filterGroup) => {
                    return renderFilterGroup(filterGroup);
                })}
            </Accordion>
        </div>
    );

    function renderOrdering() {
        return (
            <Accordion.Item
                key="ordering"
                title={`${texts.sort}: ${selectedOrderingName}`}
                initiallyOpened={false}
                onOpen={() => saveActiveIdentifier('ordering')}
                onClose={() => saveActiveIdentifier('ordering')}
            >
                {isMounted && <Ordering ordering={ordering} handleOrderingChange={handleOrderingChange} />}
            </Accordion.Item>
        );
    }

    function renderFilterGroup(filterGroup) {
        let isActive = activeIdentifiers.current.includes(filterGroup.identifier);
        const withSelection = filterGroup.selectionLabel !== '';
        const label = withSelection ?
            (
                <span className="font-bold">
                    {filterGroup.name}: {filterGroup.selectionLabel}
                </span>
            ) : (
                <span>{filterGroup.name}</span>
            );

        return (
            <Accordion.Item
                key={filterGroup.identifier}
                title={label}
                initiallyOpened={isActive}
                onOpen={() => handleFilterGroupOpen(filterGroup)}
                onClose={() => saveActiveIdentifier(filterGroup.identifier)}
            >
                {isMounted && (
                    <FilterGroupContent
                        filterGroup={filterGroup}
                        filterOptionChange={filterOptionChange}
                        preventFilterUpdate={false}
                    />
                )}
            </Accordion.Item>
        );
    }

    function saveActiveIdentifier(identifier) {
        const currentState = activeIdentifiers.current.includes(identifier);
        if (!currentState) {
            activeIdentifiers.current.push(identifier);
        } else {
            activeIdentifiers.current = activeIdentifiers.current.filter((item) => item !== identifier);
        }
    }

    function handleFilterGroupOpen(filterGroup) {
        saveActiveIdentifier(filterGroup.identifier);

        if (viewedFilterGroups.current.has(filterGroup.identifier)) {
            return;
        }

        const visibleFilters = filterGroup.filters.flatMap((filter) => {
            if (filter.rangeSlider || filter.identifier === Constants.CATEGORY_FILTER_IDENTIFIER) {
                return [];
            }

            return getAlgoliaFilterStringsFromFilterOptions(filter.identifier, filter.filterOptions);
        });

        if (!visibleFilters.length) {
            return;
        }

        viewedFilterGroups.current.add(filterGroup.identifier);
        sendViewedFiltersEvent(visibleFilters);
    }
}

export default React.memo(FilterAccordion);
